import React, { Fragment, useState } from "react";
import { ExamType, UserTypeId } from "../../common/const";
import CommonCard from "../../common/components/CommonCard";
import { Box, Grid, LinearProgress, linearProgressClasses, styled, Typography } from "@mui/material";
import theme from "../../theme";
import moment from "moment";
import CommonButton from "../../common/components/CommonButton";
import { Add } from "@mui/icons-material";
import ScoreDialog from "./ScoreDialog";
import { useSelector } from "react-redux";

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 6,
    borderRadius: 5,
    marginTop: 8,
    [`&.${linearProgressClasses.colorPrimary}`]: {
        backgroundColor: theme.palette.grey[200],
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.grey[800],
        }),
    },
    [`& .${linearProgressClasses.bar}`]: {
        borderRadius: 5,
        backgroundColor: theme.palette.secondary.main,
        ...theme.applyStyles('dark', {
            backgroundColor: theme.palette.secondary.main,
        }),
    },
}));

const Exam = ({
    Score,
    mainScore,
    totalScore
}) => {
    const [dialogOpen, setDialogOpen] = useState(false);
    const { user } = useSelector((state) => state.auth);

    return (
        <Fragment>
            <ScoreDialog
              addOpen={dialogOpen}
              setAddOpen={setDialogOpen}
            />
            <CommonCard
                borderRadius={2}
                content={
                    <Fragment>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Box>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Latest Practice Test</Typography>
                                <Typography fontSize={22} fontWeight={600}>{Score.composite_score} <span style={{ fontSize: 18, color: theme.palette.background.dark }}>/ {mainScore}</span></Typography>
                                <Typography fontSize={13} color={theme.palette.background.dark}>Taken on {moment(Score.test_date).format('MMM, DD, YYYY')}</Typography>
                            </Box>
                            {user?.user_type_id === UserTypeId.Student &&
                            (<CommonButton
                                label="Add New Score"
                                width="170px"
                                startIcon={<Add />}
                                fontWeight={600}
                                handleClick={() => setDialogOpen(true)}
                            />)}
                        </Box>
                        <Grid container spacing={2}>
                            {Score?.studentTestSectionScores?.map((a, index) => (
                                <Grid item md={6} key={index}>
                                    <CommonCard
                                        borderRadius={1}
                                        background="#EFF6FF"
                                        paddingBottom="0px"
                                        content={
                                            <Fragment>
                                                <Box display="flex" justifyContent="space-between">
                                                    <Box>
                                                        <Typography fontSize={13} color={theme.palette.background.dark} fontWeight={600}>{a.section}</Typography>
                                                        <Typography fontSize={22} fontWeight={600}>{a.score} <span style={{ fontSize: 18, color: theme.palette.background.dark }}>/ {totalScore}</span></Typography>
                                                    </Box>
                                                    <Box sx={{
                                                        background: 'white', height: '30px',
                                                        padding: '5px 10px',
                                                        borderRadius: '15px'
                                                    }}>
                                                        <Typography fontSize={13} color={theme.palette.secondary.main} fontWeight={600}>{Score?.goalData?.target_sections?.[a.section]} <span style={{ color: theme.palette.background.dark }}>Dream Score</span></Typography>
                                                    </Box>
                                                </Box>
                                                <BorderLinearProgress variant="determinate" value={((a.score / totalScore) * 100)} />
                                            </Fragment>
                                        }
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </Fragment>
                }
            />
        </Fragment>
    )
}
const ScoreBoard = ({
    testType,
    latestScore
}) => {
    return (
        testType === ExamType.SAT ? (
            <Exam Score={latestScore} mainScore={1600} totalScore={800} />
        ) : (
            <Exam Score={latestScore} mainScore={36} totalScore={36} />
        )
    )
}

export default ScoreBoard;